import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from '../model/user';
import { environment } from 'src/environments/environment';
import { ModuleCheckedResponse, Modules} from '../model/response/modules/modules-menu';
import { BaseResponse } from '../model/response/base-response';
import { ModuleCheckedBaseResponse, RoleAddRequest } from '../model/roles';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  private url: string = `${environment.apiUrl}/roles`;

  constructor(private http: HttpClient) { }

  getClienti():Observable<Role[]>{
    return this.http.get<Role[]>(`${this.url}/getAnagraficheClienti`);
  }

  getDipendenti():Observable<Role[]>{
    return this.http.get<Role[]>(`${this.url}/getdipendenti`);
  }

  getAll(): Observable<Role[]> {
    return this.http.get<Role[]>(`${this.url}/getroles`);
  }

  editRoleIsExternal(role: RoleAddRequest): Observable<BaseResponse> {
    return this.http.put<BaseResponse>(`${this.url}/roles/isexternal`, role);
  }


  getAllModules(roleId:number): Observable<ModuleCheckedBaseResponse> {
    return this.http.get<ModuleCheckedBaseResponse>(`${this.url}/getmodules/all/${roleId}`);
  }

  setRoles(roleId:number,modules:number[]): Observable<BaseResponse> {
    return this.http.post<BaseResponse>(`${this.url}/set/roles/${roleId}`,modules);
  }

  addRole(role: RoleAddRequest): Observable<BaseResponse> {
    return this.http.post<BaseResponse>(`${this.url}/roles/add`, role);
  }

  deleteRole(roleId: number): Observable<BaseResponse> {
    return this.http.delete<BaseResponse>(`${this.url}/roles/delete/${roleId}`);
  }

  //MODULES CRUD

  modulesGrid(): Observable<Modules[]> {
    return this.http.get<Modules[]>(`${this.url}/modules/grid`);
  }


  getModuleById(id:number): Observable<Modules> {
    return this.http.get<Modules>(`${this.url}/modules/id/${id}`);
  }


  addNewModule(data:Modules): Observable<BaseResponse> {
    return this.http.post<BaseResponse>(`${this.url}/modules/add`,data);
  }


  editModule(data:Modules): Observable<BaseResponse> {
    return this.http.put<BaseResponse>(`${this.url}/modules/edit`,data);
  }

  deleteModule(id:number): Observable<BaseResponse> {
    return this.http.delete<BaseResponse>(`${this.url}/modules/delete/${id}`);
  }

  changeShowToUser(moduledId: number, showToUser: boolean): Observable<BaseResponse> {
    return this.http.put<BaseResponse>(`${this.url}/modules/show-hide-user/${moduledId}/${showToUser}`, null);
  }
}
